import { Building2 } from 'lucide-react';

const LoadingScreen = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-sidebar to-sidebar/90 flex flex-col items-center justify-center">
      <img 
        src="/logo.png" 
        alt="Belkom logo" 
        className="h-20 w-auto mb-4 animate-fade-in"
      />
      <div className="flex items-center space-x-2 mt-2">
        <div className="h-2 w-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
        <div className="h-2 w-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
        <div className="h-2 w-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
      </div>
    </div>
  );
};

export default LoadingScreen;